<template>
  <div>
    <div class="product-container">
      <Bread
        first-name="产品中心"
        metertype="智慧水务"
        meter-name="水控机"
      ></Bread>
      <div class="top-title">
        <h1>西安星年物联网</h1>
      </div>
      <div class="info">
        <el-row :gutter="16">
          <el-col :span="16">
            <h1>水控机（模块）</h1>
            <div class="introduce">
              <div class="title">产品介绍</div>
              <div class="intro-text">
                <p>
                  随着人们环保意识的不断增强，我司研发了智能水控机模块以供人们节约用水，可用于饮水台，公共浴室，校园学生用水等场景。智能节水控制器，脉冲流量表、电动阀、刷卡收费控制器结合一体化设计，完全堵塞了员工（学生）偷水现象及容易人为破坏现象。
                </p>
              </div>
            </div>
            <div class="trait">
              <div class="title">功能特点</div>

              <div class="intro-text">
                <p>
                  1、 计时、计量可选择；防窥水，防复制；
                </p>
                <p>
                  2、可做一卡通，方便使用；
                </p>
                <p>
                  3、计量型，霍尔计量，精确度0.06升；
                </p>
                <p>
                  4、霍尔设定脉冲数，提高计量准确性；
                </p>
                <p>
                  5、预留485数据接口协议；
                </p>
                <p>
                  6、数据记忆功能，参数设定后会保存在存储器，断电后不需要重新设置
                </p>
              </div>
            </div>
            <div></div>
          </el-col>
          <el-col :span="8">
            <div class="meter-img">
              <img src="@/svg/contorl.png" />
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
export default {}
</script>
<style lang="scss" scope>
.box {
  font-size: 42px;
}
.top-title {
  padding: 100px 0 0 0;
  border-bottom: 4px solid #4e56c5;
  h1 {
    color: #4e56c5;
  }
}
.info {
  h1 {
    text-indent: 2cm;
    color: #3ab0e7;
  }
  .introduce {
    padding: 60px 0 0 0;
    .title {
      text-indent: 2cm;
      font-size: 24px;
      color: #3ab0e7;
    }
    .intro-text {
      padding: 20px 0 0 20px;
      text-indent: 2cm;
      line-height: 30px;
    }
  }
  .trait {
    padding: 60px 0 0 0;
    .title {
      text-indent: 2cm;
      font-size: 24px;
      color: #3ab0e7;
    }
    .intro-text {
      padding: 20px 0 0 20px;
      text-indent: 2cm;
      line-height: 30px;
    }
  }
  background-color: #fff;
  margin: 100px 0 0 0;
  .meter-img {
    img {
      width: 370px;
    }
  }
}
</style>
